






















































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { activityExtendedFilterFields } from '@/config/activities';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import moment from 'moment';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import { ActivityExtendedFilters } from '@activities/interfaces/activity';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';

@Component({
  name: 'bpc-membership-form',
  components: {
    'bpc-input': Input,
    'bpc-select': Select,
    'bpc-entity-select': EntitySelect,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-datepicker': Datepicker,
    'bpc-multi-select': MultiSelect,
  },
})
export default class ActivityExtendedFilterForm extends Vue {
  // PROPS
  @Prop(Object) readonly initialData: ActivityExtendedFilters;
  @Prop({ type: Boolean, default: false }) readonly hideFilterType;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: ActivityExtendedFilters;
  @Prop({
    type: String,
  })
  readonly cancelButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;
  @Prop({
    type: String,
  })
  readonly searchButtonsPortalTarget: string;
  // DATA

  saving: boolean = false;
  timestamp = moment().unix();

  // COMPUTED

  get formModel(): ActivityExtendedFilters {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return activityExtendedFilterFields;
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get noLabel() {
    return {
      showLabel: false,
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }

  onSearch() {
    this.$emit('search', this.formModel);
  }

  onSave() {
    this.$emit('save', this.formModel);
  }

  onClose() {
    this.$emit('close');
  }

  // WATCHERS
}
